import React from 'react';
import { Navbar } from '../components/Navbar';
import { StickyFooter } from '../components/StickyFooter';
import { ShieldCheckIcon } from 'lucide-react';
export function TemporaryHealthcareAides() {
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-987">
      <Navbar data-id="element-988" />
      <main className="flex-1" data-id="element-989">
        <section className="w-full bg-gray-50 py-16 lg:py-24 border-b border-gray-100" data-id="element-990">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-991">
            <div className="inline-flex items-center gap-2 bg-soft-teal text-accent-teal-dark text-xs font-semibold px-3 py-1.5 rounded-full mb-4" data-id="element-992">
              <ShieldCheckIcon className="w-3.5 h-3.5" data-id="element-993" />
              Services
            </div>
            <h1 className="text-4xl sm:text-5xl font-extrabold text-text-dark tracking-tight mb-6" data-id="element-994">
              Temporary Healthcare Aides
            </h1>
            <p className="text-lg text-text-muted max-w-2xl mx-auto leading-relaxed" data-id="element-995">
              Reliable, vetted temporary healthcare aides ready to support your
              facility's staffing needs on short notice.
            </p>
          </div>
        </section>
        <div className="max-w-3xl mx-auto px-4 py-16 text-text-muted leading-relaxed space-y-6" data-id="element-996">
          <p data-id="element-997">
            Our Temporary Healthcare Aides (THA) provide essential support to
            nursing staff and patients in various healthcare settings. They are
            trained to assist with daily living activities, ensuring patients
            receive compassionate and competent care.
          </p>
          <p data-id="element-998">
            Whether you need coverage for a single shift, a short-term leave, or
            ongoing support during peak periods, our platform connects you with
            qualified THAs in minutes. Every aide on our platform has undergone
            rigorous background checks and clinical vetting by our Registered
            Nurse leadership team.
          </p>
        </div>
      </main>
      <StickyFooter data-id="element-999" />
    </div>;
}